module.exports = function () {
    if ( document.querySelector(".header") ) {
        const header = document.querySelector(".header");
        const ham = document.querySelector(".header__ham");
        const portfolioFilter = document.querySelector(".portfolio-filter");
        const portfolioFilterStart = document.querySelector(".portfolio-filter-start");
        
        let pageScroll = window.scrollY;
        let scrolled = false;
        let currentHeaderHeight = header.getBoundingClientRect().height;

        window.addEventListener("scroll", headerScrolled);
        header.style.maxHeight = header.getBoundingClientRect().height + 'px';

        if ( window.scrollY > 50 ) {
            header.classList.add("header--bg");
        }
        else {
            header.classList.remove("header--bg");
        }

        function headerScrolled() {
            if ( portfolioFilter ) {
                if ( portfolioFilterStart.getBoundingClientRect().top <= 0) {
                    if ( !portfolioFilter.classList.contains('fixed') ) {
                        portfolioFilterStart.style.height = `${portfolioFilter.clientHeight}px`;
                        portfolioFilter.classList.add("fixed");
                        portfolioFilter.classList.remove("relative");
                    }
                }
                else if ( portfolioFilterStart?.getBoundingClientRect().top > header.clientHeight ) {
                    if ( portfolioFilter.classList.contains('fixed') ) {
                        portfolioFilter.classList.remove("fixed");
                        portfolioFilter.classList.add("relative");
                        portfolioFilterStart.style.height = null;
                        portfolioFilter.style.transitionDuration = null;
                        portfolioFilter.style.transform = `translateY(0px)`;

                        setTimeout(() => {
                            portfolioFilter.style.transitionDuration = '300ms';
                        },1);
                    }
                }
            }
            if ( pageScroll < window.scrollY && window.scrollY > 10 ) {
                // Scroll Down
                if ( portfolioFilter && (portfolioFilterStart?.getBoundingClientRect().top <= 0 || header.classList.contains('header--scrolled'))  ) {
                    portfolioFilter.style.transform = `translateY(0px)`;
                }
                
                header.classList.add("header--scrolled");

                if ( !scrolled ) {
                    setTimeout(() => {
                        if ( header.classList.contains("header--scrolled") && window.scrollY > 50 ) {
                            header.classList.add("header--bg");
                            scrolled = true;
                        }
                    }, 300);
                }
            }
            else {
                // Scroll up
                if ( portfolioFilter ) {
                    if ( portfolioFilterStart?.getBoundingClientRect().top < header.clientHeight && portfolioFilter.classList.contains('fixed') ) {
                        portfolioFilter.style.transform = `translateY(${header.clientHeight}px)`;
                    }
                }
                
                header.classList.remove("header--scrolled");

                if ( scrolled ) {
                    setTimeout(() => {
                        if ( !header.classList.contains("header--scrolled") && window.scrollY < 50 && !document.querySelector(".header__navigation .menu-item-has-children.open") ) {
                            header.classList.remove("header--bg");
                            scrolled = false;
                        }
                    }, 300);
                }
            }

            pageScroll = window.scrollY;
        }

        if ( document.querySelector(".header__navigation") ) {
            const nav = document.querySelector(".header__navigation"),
                menuParent = nav.querySelectorAll(".menu-item-has-children");

            if ( menuParent ) {
                menuParent.forEach(menu => {
                    menu.addEventListener("mouseenter", () => {
                        const subMenu = menu.querySelector(".sub-menu"),
                            subMenuHeight = subMenu.getBoundingClientRect().height;

                        subMenu.classList.remove("!opacity-0");

                        if ( !header.classList.contains("header--scrolled") ) {
                            header.classList.add("header--bg");
                        }

                        header.classList.add("header--open");
                        header.style.maxHeight = `${currentHeaderHeight + subMenuHeight - 16}px`;
                        menu.classList.add("open");
                    })

                    menu.addEventListener("mouseleave", () => {
                        if ( window.scrollY < 50 ) {
                            menu.querySelector(".sub-menu").classList.add("!opacity-0");
                            menu.classList.remove("open");

                            setTimeout(() => {
                                if ( !header.querySelector(".header__navigation .menu-item.open") ) {
                                    header.classList.remove("header--bg");

                                    header.style.maxHeight = `${currentHeaderHeight}px`;

                                    // setTimeout(() => {
                                    //     if ( !header.querySelector(".header__navigation .menu-item.open") ) {
                                    //         header.style.maxHeight = `${currentHeaderHeight}px`;   
                                    //     }
                                    // }, 350);
                                }
                            }, 100)

                            // menu.classList.remove("open");
                            // header.style.maxHeight = `${currentHeaderHeight}px`;
                            //
                            // if ( !header.querySelector(".header__navigation .menu-item.open") ) {
                            //     header.classList.remove("header--open");
                            //
                            //     if ( !header.querySelector(".header__navigation .menu-item.open") ) {
                            //         header.classList.remove("header--bg");
                            //     }
                            // }
                        }
                        else {
                            menu.classList.remove("open");
                            header.style.maxHeight = `${currentHeaderHeight}px`;

                            setTimeout(() => {
                                if ( !header.querySelector(".header__navigation .menu-item.open") ) {
                                    header.classList.remove("header--open");
                                }
                            }, 300)
                        }
                    })
                })
            }
        }

        if ( document.querySelector(".header__mobile") ) {
            const mobileMenu = document.querySelector(".header__mobile");
            let isOpen = false;

            const openMenu = () => {
                isOpen = true;

                document.body.classList.add("overflow-hidden");
                ham.classList.add("open");
                header.classList.add("header--mobile-open");
                mobileMenu.classList.add("open");
            }

            const closeMenu = () => {
                isOpen = false;

                document.body.classList.remove("overflow-hidden");
                ham.classList.remove("open");
                header.classList.remove("header--mobile-open");
                mobileMenu.classList.remove("open");
            }

            ham.addEventListener("click", () => {
                if ( isOpen ) {
                    closeMenu()
                }
                else {
                    openMenu()
                }
            })
        }
    }
}